var map = {
	"./Header-mobile.vue": 60,
	"./Hello.vue": 337,
	"./Home.vue": 338,
	"./Image-home.vue": 339,
	"./Image-inside.vue": 340,
	"./Inside.vue": 341,
	"./News.vue": 61,
	"./Page.vue": 342,
	"./Progetti.vue": 343,
	"./Savethedate.vue": 344,
	"./Site-footer.vue": 345,
	"./Site-header.vue": 346,
	"./Site-navbar.vue": 347,
	"./Site-side.vue": 62,
	"./Tema.vue": 348,
	"./Tipologia.vue": 349
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;


//////////////////
// WEBPACK FOOTER
// ./src/components ^\.\/.*\.vue$
// module id = 369
// module chunks = 0